import React from 'react';

import useQRCodeGenerator from 'react-hook-qrcode-svg';
import JsBarcode from 'jsbarcode';

import {
  // PDFViewer,
  PDFDownloadLink,
  Document,
  View,
  Page,
  Text,
  StyleSheet,
  Font,
  Image,
  Svg,
  Rect,
  Path,
  Defs,
  LinearGradient,
  Stop,
} from '@react-pdf/renderer';

const QRCODE_SIZE = 80;
const QRCODE_LEVEL = 'Q';
const QRCODE_BORDER = 0;

function generateBarcode(value) {
  const canvas = document.createElement('canvas');
  JsBarcode(canvas, value, {
    format: 'CODE128',
    displayValue: false,
    height: 40,
    width: 80,
    margin: 0,
  });
  return canvas.toDataURL();
}

Font.register({
  family: 'Poppins',
  fonts: [
    { src: '/admin/pdf-assets/poppins-regular.ttf' },
    { src: '/admin/pdf-assets/poppins-medium.ttf', fontWeight: 'medium' },
    { src: '/admin/pdf-assets/poppins-bold.ttf', fontWeight: 'bold' },
  ],
});

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    padding: 20,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  text: { fontFamily: 'Poppins', fontSize: 8 },
  textBold: { fontFamily: 'Poppins', fontSize: 8, fontWeight: 'bold' },
  title: { fontFamily: 'Poppins', fontSize: 20, fontWeight: 'bold' },
  caption: { fontFamily: 'Poppins', fontSize: 7 },
  captionBold: { fontFamily: 'Poppins', fontSize: 7, fontWeight: 'bold' },
  tagline: {
    fontFamily: 'Poppins',
    fontWeight: 'medium',
    fontSize: 6,
    color: '#ae437c',
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },
});

function PartyDetails({ lines }) {
  return (
    lines.map((line, lineIndex) => (
      <View
        // eslint-disable-next-line react/no-array-index-key
        key={`${line}-${lineIndex}`}
        style={{ flexDirection: 'row', flexWrap: 'wrap' }}
      >
        {line.trim().split(/\s+/g).reduce(
          (agr, word, wordIndex, wordsArray) => {
            agr.push(
              <Text
                // eslint-disable-next-line react/no-array-index-key
                key={`${word}-${wordIndex}`}
                style={
                  lineIndex === 0 ? styles.textBold : styles.text
                }
              >
                {word}
              </Text>
            );
            if (wordIndex < wordsArray.length - 1) {
              agr.push(
                <Text
                  // eslint-disable-next-line react/no-array-index-key
                  key={`_space-${wordIndex}`}
                  style={
                    lineIndex === 0 ? styles.textBold : styles.text
                  }
                >
                  {' '}
                </Text>
              );
            }
            return agr;
          },
          [],
        )}
      </View>
    ))
  );
}

export function AirWayBill({
  orderNumber,
  orderDate,
  orderItems,
  cod,
  from,
  to,
  shippingProvider,
  referenceId,
  referenceCode,
  mode,
}) {
  const { path, viewBox } = useQRCodeGenerator(
    referenceCode, QRCODE_LEVEL, QRCODE_BORDER
  );

  const barcodeImageUrl = generateBarcode(referenceCode);

  return (
    <Document>
      <Page size={[400, 600]} style={styles.page}>
        <View style={{ paddingBottom: 20 }}>
          <View style={styles.row}>
            <Image
              src={mode === 'bw'
                ? '/admin/pdf-assets/logo-icon-bw.png'
                : '/admin/pdf-assets/logo-icon-color.png'}
              style={{ width: 82, height: 82 }}
            />
            <View
              style={{
                alignItems: 'flex-end',
                justifyContent: 'space-between',
              }}
            >
              <View
                style={{
                  alignItems: 'flex-end',
                }}
              >
                <Image
                  src="/admin/pdf-assets/logo-text.png"
                  style={{ height: 25, marginRight: -7 }}
                />
                <Text
                  style={{
                    ...styles.tagline,
                    ...(mode === 'bw' && { color: 'black' }),
                  }}
                >
                  Start Selling Online Today
                </Text>
              </View>
              <View
                style={{
                  width: 20,
                  borderTop: '0.5px solid black',
                }}
              />
              <View
                style={{
                  alignItems: 'flex-end',
                }}
              >
                <Text style={styles.captionBold}>Packman Portal LLC</Text>
                <Text style={styles.caption}>
                  Learn More at:
                  {' '}
                  <Text style={styles.captionBold}>packman.app</Text>
                </Text>
                {/* <Text style={styles.caption}>
                  help@packman.app  |  +971 4 223 1377
                </Text> */}
              </View>
            </View>
          </View>
          <View
            style={{
              ...styles.row,
              marginTop: 20,
              paddingTop: 20,
              borderTop: '0.5px solid black',
            }}
          >
            <View>
              <Text style={styles.text}>Order number:</Text>
              <Text style={styles.title}>{orderNumber}</Text>
            </View>
            <Text style={styles.caption}>{orderDate}</Text>
          </View>
        </View>
        {/* BODY */}
        <View>
          <View style={{ ...styles.row, marginBottom: 20 }}>
            <View
              style={{
                flexDirection: 'column',
                justifyContent: 'space-between',
                flex: 1,
                paddingRight: 30,
                width: '50%',
              }}
            >
              <View>
                {orderItems.map((item, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Text key={index} style={styles.text}>{item}</Text>
                ))}
              </View>
              {/* COD */}
              {!!cod && (
                <View
                  style={{
                    width: '100%',
                    position: 'relative',
                    marginTop: 10,
                    marginBottom: -3,
                  }}
                >
                  <Svg
                    width={200}
                    height={32}
                    viewBox="0 0 200 32"
                    style={{
                      position: 'absolute',
                      width: '100%',
                      left: 0,
                      bottom: 0,
                    }}
                  >
                    <Defs>
                      <LinearGradient id="grad" x1="0" y1="0" x2="0" y2="1">
                        <Stop offset="0" stopColor="#ac417b" />
                        <Stop offset="1" stopColor="#f6a717" />
                      </LinearGradient>
                    </Defs>
                    <Rect
                      x="0"
                      y="0"
                      width={200}
                      height={32}
                      fill={mode === 'bw' ? 'black' : 'url(#grad)'}
                    />
                  </Svg>
                  <View style={{ ...styles.row, padding: 10, color: 'white' }}>
                    <Text style={styles.text}>COD:</Text>
                    <Text style={styles.textBold}>{cod}</Text>
                  </View>
                </View>
              )}
            </View>
            <View
              style={{
                paddingLeft: 30,
                borderLeft: '0.5px solid black',
                width: '50%',
              }}
            >
              <View style={{ paddingRight: 30 }}>
                <Text style={styles.text}>From:</Text>
                <Text style={styles.text}> </Text>
                <PartyDetails lines={from} />
                <Text style={styles.text}> </Text>
                <Text style={styles.text}>To:</Text>
                <Text style={styles.text}> </Text>
                <PartyDetails lines={to} />
              </View>
            </View>
          </View>
        </View>
        <View style={{ borderTop: '0.5px solid black' }}>
          <View style={{ ...styles.row, marginTop: 20 }}>
            <Text style={styles.text}>
              Shipping provided by:
              {' '}
              <Text style={styles.textBold}>{shippingProvider}</Text>
            </Text>
            <Text style={styles.text}>
              Reference ID:
              {' '}
              <Text style={styles.textBold}>{referenceId}</Text>
            </Text>
          </View>
          <View
            style={{ ...styles.row, marginTop: 20 }}
          >
            <Image
              src={barcodeImageUrl}
              style={{ width: 260, height: QRCODE_SIZE }}
            />
            <Svg
              width={QRCODE_SIZE}
              height={QRCODE_SIZE}
              viewBox={viewBox}
            >
              <Defs>
                <LinearGradient
                  x1={0}
                  y1={0}
                  x2={1}
                  y2={1}
                  id="packmanLinearGradient"
                >
                  <Stop stopColor="#ad427d" />
                  <Stop stopColor="#f5a816" />
                </LinearGradient>
              </Defs>
              <Path
                d={path}
                fill={mode === 'bw' ? 'black' : "url('#packmanLinearGradient')"}
              />
            </Svg>
          </View>
        </View>
      </Page>
    </Document>
  );
}

export function DownloadAirWayBill({
  fileName,
  children,
  ...props
}) {
  return (
    <>
      <PDFDownloadLink
        document={<AirWayBill {...props} />}
        fileName={fileName || `${props.orderNumber}.pdf`}
      >
        {children}
        {/* eslint-disable-next-line no-unused-vars */}
        {/* {({ blob, url, loading, error }) => (
          loading ? 'Loading...' : children)} */}
      </PDFDownloadLink>
    </>
  );
}

export default AirWayBill;
